export default "__VITE_ASSET__DExmdJlT__"